export const SHOW_UPGRADE_CARD_MODAL = 'SHOW_UPGRADE_CARD_MODAL'
export const showUpgradeCardModal = (payload) => ({
  type: SHOW_UPGRADE_CARD_MODAL,
  payload
})

export const HIDE_UPGRADE_CARD_MODAL = 'HIDE_UPGRADE_CARD_MODAL'
export const hideUpgradeCardModal = (payload) => ({
  type: HIDE_UPGRADE_CARD_MODAL,
  payload
})

export const SHOW_PAYMENT_MODAL = 'SHOW_PAYMENT_MODAL'
export const setShowPaymentModal = (payload) => ({
  type: SHOW_PAYMENT_MODAL,
  payload
})

export const UPGRADE_QR_PAYLOAD = {
  title: 'Upgrade for QR Codes',
  desc: 'Easily share your link via a QR code that your visitors can scan with their phone.',
  gif: '/assets/img/gifs/qr.gif',
  cta: 'Download QR Code'
}

export const UPGRADE_CUSTOM_DOMAIN = {
  title: 'Upgrade to connect your own website domain',
  desc: 'Use your own brand and upload content to your own website domain',
  cta: 'Connect domain',
  gif: '/assets/img/gifs/custom-domain.gif'
}



export const UPGRADE_FEEDBACK_PAYLOAD = {
  title: 'Upgrade for Feedback Mode',
  desc: 'Allow visitors to comment on your work',
  gif: '/assets/img/gifs/feedback.gif',
  cta: 'Enable Feedback Mode'
}

export const UPGRADE_PASSWORD_PROTECT_PAYLOAD = {
  title: 'Upgrade for Password Protection',
  desc: 'Make your link private by adding a layer of security',
  gif: '/assets/img/gifs/password-protection.gif',
  cta: 'Enable Protection'
}

export const UPGRADE_CAPTURE_EMAILS_PAYLOAD = {
  title: 'Upgrade to Capture Emails',
  desc: 'Capture potential leads by requiring visitors to enter their email address',
  gif: '/assets/img/gifs/email-capture.gif',
  cta: 'Capture Emails'
}

export const UPGRADE_PRESENTATION_PAYLOAD = {
  title: 'Upgrade for Presentation Mode',
  desc: 'Displays PDF as a slideshow',
  gif: '/assets/img/gifs/presentation-mode.gif',
  cta: 'Enter Presentation Mode'
}

export const UPGRADE_EDIT_CODE_PAYLOAD = {
  title: 'Upgrade to Edit Code',
  desc: 'Unlock full control by editing your site’s HTML, CSS, and JavaScript directly.',
  gif: '/assets/img/gifs/edit-code.gif',
  cta: 'Edit Code'
}

